import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var addNoteRes;
export const addNoteTodo = createAsyncThunk('addNote', async (val) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    // console.log(val)

    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'learner/add_note',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "course_id": val.course_id,
                "note": val.notes,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return addNoteRes = res.data
    } catch (error) {
        return addNoteRes = error.response.data
    }
})